import React from "react";
import { Workflow, useBCMSContext, useModel, BCMSRecord, BCMSDefaultModel } from "@bcm-dev/bcms-vite";
import Classes, { Card } from "model";

import AddCardPage from "components/pages/AddCardPage";
import UserVerificationPage from "components/pages/UserVerificationPage";
import AddCardVerificationPage from "components/pages/AddCardVerificationPage";
import UserRegistrationPage from "components/pages/UserRegistrationPage";

const steps = [
    AddCardPage,
    AddCardVerificationPage,
    UserVerificationPage,
    UserRegistrationPage
    //AddCardVerificationPage
    //UserRegistrationPage
    //<AddCardPage />,
    //<UserVerificationPage />,
    //<AddCardVerificationPage />,
    //<UserRegistrationPage />
];

export default function AddCardWorkflow(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const defaultData = getDefaultCard(context);

    const constructor = value => {
        const { card, expDate } = getDefaultCard(context);
        const expDatePlaceholder = value.expDate ?? expDate;
        card.expDatePlaceholder = expDatePlaceholder;
        const cardRecord = { ...card.record, ...value.card };
        const newCard = Card.init(cardRecord);
        newCard.expDatePlaceholder = expDatePlaceholder;
        
        return { card: newCard };
    }; 

    return <Workflow value={ defaultData } steps={ steps } constructor={ constructor } />
    /*const controller = useBCMSContext();
    const value = getDefaultCard(controller);

    const constructor = value => {
        const { card, expDate } = getDefaultCard(controller);
        const cardRecord = { ...card.record, ...value.card };
        
        return { card: Card.init(cardRecord), expDate: value.expDate ?? expDate };
    };  

    return <Workflow value={ value } steps={ steps } constructor={ constructor } />*/
}

export const getWorkflowSteps = () => steps;

export const getDefaultCard = controller => {
    const branding = controller.state.branding.options;
    const card = branding.include_debit_chw23 === "false"
        ? BCMSDefaultModel.creditCard()
        : BCMSDefaultModel.debitCard();
    card.number = "";
    card.expDatePlaceholder = "";
    card.id = Card.nextID();

    if(branding.activate_card_chw23 === "false") {
        card.active = true;
    }

    return { card };
}

/*export const getDefaultCard = controller => {

    BCMSRecord.globalControllerFor([ Card ], controller);
    const branding = controller.state.branding.options;

    const card = branding.include_debit_chw23 === "false"
        ? BCMSDefaultModel.creditCard()
        : BCMSDefaultModel.debitCard();
    const expDate = "";

    card.id = Card.nextID();

    if(branding.activate_card_chw23 === "false") {
        card.active = true;
    }

    return { card, expDate };
};*/